import { createReducer } from 'redux-act';
import Immutable from 'seamless-immutable';
import RulesetActions from './ruleset-actions';

const initialState = Immutable({ rulesets: [], isFetching: false, hasFetched: false });

/** Updates ruleset state from actions. */
const reducer = createReducer((on) => {
  on(RulesetActions.fetchRulesets, (state) => state.set('isFetching', true));

  on(RulesetActions.fetchRulesetsFailure, (state) => state.set('isFetching', false).set('hasFetched', true));

  on(RulesetActions.fetchRulesetsSuccess, (state, { rulesets }) => {
    return state.merge({ isFetching: false, hasFetched: true, rulesets });
  });

  on(RulesetActions.updateRulesetSuccess, (state, { ruleset }) =>
    state.set(
      'rulesets',
      state.rulesets.map((existingRuleset) => (existingRuleset.id === ruleset.id ? ruleset : existingRuleset))
    )
  );

  on(RulesetActions.deleteRulesetSuccess, (state, id) =>
    state.set(
      'rulesets',
      state.rulesets.filter((ruleset) => ruleset.id !== id)
    )
  );
}, initialState);

export default reducer;
